import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";
import { IWithThemeProps } from "Components/Generic/Theme/IWithThemeProps";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { isString } from "Utils/String";
import { HeaderButton } from "./Button";
import { useHeaderStyles } from "./UseHeaderStyles";
import { IHeaderProps } from "./IHeaderProps";

export const Header = WithTheme((props: IHeaderProps & IWithThemeProps): JSX.Element => {
  const {
    headerTitle,
    theme: { spacing }
  } = props;
  const styles = useHeaderStyles();

  return (
    <Stack
      grow
      horizontal
      horizontalAlign="space-between"
      tokens={{ childrenGap: spacing.s2 }}
      verticalAlign="center"
      verticalFill
      className={styles.root}
    >
      <HeaderButton {...props} />
      <Stack.Item grow align="center" className={styles.item}>
        {isString(headerTitle)
          ? (
            <Text variant="xLarge" block nowrap>
              {headerTitle}
            </Text>
          )
          : (
            headerTitle
          )}
      </Stack.Item>
    </Stack>
  );
});
